import clsx from "clsx";
import { NavigationLink } from "@/components/Navigation/NavigationLink";
import { AppText } from "@/components/Text/AppText";
import { useAppSelector } from "@/hooks/types";
import { getIs1TemplateTenant, getTenant } from "@/store/tenant/selectors";
import { AppRoutes, SiteRoutes } from "@/types/routes";
import { addUTMParams } from "@/utils/tracking";

const OneTemplaineMainLinks = [
    {
        to: `/${AppRoutes.Examples}`,
        label: "Resume Examples",
        desktopOnly: true,
    },
    { to: `/${AppRoutes.Profile}?tab=credits`, label: "Credits" },
    {
        to: addUTMParams(SiteRoutes.Blog, {
            source: "app",
            medium: "internal_link",
            campaign: "footer_navigation",
            content: "blog",
        }),
        label: "Blog",
        external: true,
    },
    {
        to: addUTMParams(SiteRoutes.About, {
            source: "app",
            medium: "internal_link",
            campaign: "footer_navigation",
            content: "about",
        }),
        label: "About",
        external: true,
    },
    { to: SiteRoutes.Terms, label: "Terms", external: true },
    { to: SiteRoutes.PrivacyPolicy, label: "Privacy", external: true },
];

const QuickLink = ({
    label,
    desktopOnly,
    external,
    to,
}: {
    label: string;
    desktopOnly: boolean;
    external: boolean;
    to: string;
}) => (
    <li
        key={label}
        className={clsx(desktopOnly && "hidden lg:block")}
    >
        <NavigationLink
            to={
                external
                    ? addUTMParams(to, {
                          source: "app",
                          medium: "internal_link",
                          campaign: "footer_navigation",
                          content: label.toLowerCase(),
                      })
                    : to
            }
            target={external ? "_blank" : undefined}
            className={clsx(
                "!px-0 text-xs text-white/90 transition-colors hover:text-white",
            )}
        >
            {label}
        </NavigationLink>
    </li>
);

export const FooterQuickLinks = () => {
    const tenant = useAppSelector(getTenant);
    const is1TemplateTenant = useAppSelector(getIs1TemplateTenant);
    if (!tenant) return null;
    const { externalLinks } = tenant;

    return (
        <div className="flex flex-col gap-2">
            <AppText
                variant="contextheading"
                className="text-xs text-white"
            >
                Quick Links
            </AppText>
            <ul className="grid grid-cols-2 gap-1">
                {is1TemplateTenant ? (
                    OneTemplaineMainLinks.map(link => (
                        <QuickLink
                            key={link.label}
                            label={link.label}
                            desktopOnly={link.desktopOnly ?? false}
                            external={false}
                            to={link.to}
                        />
                    ))
                ) : (
                    <>
                        {externalLinks.termsOfService && (
                            <QuickLink
                                label="Terms"
                                desktopOnly={false}
                                external={true}
                                to={externalLinks.termsOfService}
                            />
                        )}
                        {externalLinks.privacyPolicy && (
                            <QuickLink
                                label="Privacy"
                                desktopOnly={false}
                                external={true}
                                to={externalLinks.privacyPolicy}
                            />
                        )}
                    </>
                )}
            </ul>
        </div>
    );
};
